export function getRandomNumber() {
  return Math.random();
}
